<template>
    <div class="mp-bar" :style="styles"></div>
</template>
<script>
    export default {
        name: 'mp-bar',
        props: {
            value: {},
            color: {},
        },
        computed: {
            styles() {
                return {
                    width: this.value ? `${this.value}%` : `36px`,
                    backgroundColor: this.color,
                }
            },
        },
    }
</script>
